import React from "react";
import "./EmotionalSection.scss";
import emotionalImage from "../../images/emotional.jpg";

const EmotionalSection = () => {
  return (
    <section className="emotionalDreams">
      <div className="container">
        <div className="emotionalDreams__wrapper">
          <div className="emotionalDreams__content">
            <span className="emotionalDreams__tag">
              Un momento que merece algo inolvidable
            </span>

            <h2>Sabemos que tus XV no son cualquier fiesta…</h2>

            <p>
              Son un momento único, lleno de ilusión, emoción y sueños por
              cumplir. No se trata solo de organizar un evento, sino de vivir
              una experiencia que recordarás para siempre.
            </p>

            <p>
              En <strong>Dreams XV</strong> reunimos inspiración, ideas y
              proveedores para ayudarte a encontrar todo más fácil, más bonito y
              en un solo lugar.
            </p>

            <div className="emotionalDreams__points">
              <div className="emotionalDreams__point">
                <span className="emotionalDreams__icon">✨</span>
                <span>Es un momento único</span>
              </div>

              <div className="emotionalDreams__point">
                <span className="emotionalDreams__icon">👑</span>
                <span>Es un sueño que quieres perfecto</span>
              </div>

              <div className="emotionalDreams__point">
                <span className="emotionalDreams__icon">💛</span>
                <span>Es un día que recordarás toda la vida</span>
              </div>
            </div>
          </div>

          <div className="emotionalDreams__image">
            <div className="emotionalDreams__imageGlow"></div>
            <img
              src={emotionalImage}
              alt="Quinceañera en un momento elegante y especial"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmotionalSection;